import forEach from '../../../../javascripts/dom/forEach';

const history = document.querySelectorAll('[data-js-module="o-history"]');

const init = async () => {
  const { default: History } = await import(/* webpackChunkName: "o-history" */ './history');
  forEach(history, (index, element) => new History(element));
};

if (history.length) init();
